<template>
  <div>
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <form>
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label for="signup-company-lastname"
                >{{ $t('form.companyLastname') }}
              </label>
              <input
                v-model="lastname"
                type="text"
                class="form-control"
                id="signup-company-lastname"
                :placeholder="$t('form.companyLastname')"
                :readonly="isInvited"
              />
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label for="signup-company-firstname">{{
                $t('form.companyFirstname')
              }}</label>
              <input
                v-model="firstname"
                type="text"
                class="form-control"
                id="signup-company-firstname"
                :placeholder="$t('form.companyFirstname')"
                :readonly="isInvited"
              />
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="signup-company-country"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="signup-company-country"
                  >{{ $t('form.country') }}
                  <sup class="text-danger">*</sup></label
                >
                <select
                  class="form-control p-0 pl-2"
                  v-model="country"
                  id="signup-company-country"
                  :placeholder="$t('form.country')"
                  :class="{ 'is-invalid': errors.length }"
                  @change="validationObeserverValidate"
                >
                  <option></option>
                  <option
                    v-for="item in countries"
                    :value="{ name: item.name, id: item.id }"
                    :key="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="email"
                rules="required|email"
                v-slot="{ errors }"
                mode="lazy"
              >
                <label for="signup-company-email"
                  >{{ $t('form.email') }}
                  <sup class="text-danger">*</sup></label
                >
                <input
                  v-model="email"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                  id="signup-company-email"
                  :placeholder="$t('form.email')"
                  :readonly="isInvited"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="name"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="signup-company-company-name"
                  >{{ $t('form.companyName') }}
                  <sup class="text-danger">*</sup></label
                >
                <input
                  v-model="name"
                  type="text"
                  class="form-control"
                  id="signup-company-company-name"
                  :class="{ 'is-invalid': errors.length }"
                  :placeholder="$t('form.companyName')"
                  :readonly="country === $t('france') || isInvited"
                />
              </validation-provider>
            </div>
          </div>
          <!-- <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="trade"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="trade"
                  >{{$t('form.tradeName')}} <sup class="text-danger">*</sup></label
                >
                <input
                  v-model="trade"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': errors.length}"
                  id="trade-name"
                  :placeholder="$t('form.tradeName')"
                />
              </validation-provider>
            </div>
          </div> -->
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="siret"
                rules="required_if:country,$t('france')"
                v-slot="{ errors }"
                ref="mysiret"
              >
                <label for="signup-company-siret"
                  >{{ $t('form.siretNumber') }}
                  <sup v-if="country == $t('france')" class="text-danger"
                    >*</sup
                  ></label
                >
                <input
                  v-model="siret"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                  id="signup-company-siret"
                  :placeholder="$t('form.siretNumber')"
                  v-mask="'##############'"
                  @blur.prevent.stop="handleCompanySIRET($event)"
                  maxlength="14"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-8">
            <div class="form-group">
              <label for="legal">{{ $t('form.nafCode') }} </label>
              <treeselect
                :maxHeight="200"
                v-model="nafCode"
                :multiple="false"
                :options="options"
                :placeholder="$t('form.nafCode')"
                :readonly="isInvited"
                @select="setCodeNAf"
              />
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="form-group">
              <validation-provider
                name="local"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="signup-company-local">
                  {{ $t('form.local') }}
                  <sup class="text-danger">*</sup>
                </label>
                <select
                  class="form-control p-0 pl-2"
                  v-model="local"
                  id="signup-company-local"
                  :placeholder="$t('form.local')"
                  :class="{ 'is-invalid': errors.length }"
                >
                  <option value="fr">FR</option>
                  <option value="en">EN</option>
                </select>
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="legal"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="signup-company-legal"
                  >{{ $t('form.legalForm') }}
                  <sup class="text-danger">*</sup></label
                >
                <input
                  v-model="legalForm"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                  id="signup-company-legal"
                  :placeholder="$t('form.legalForm')"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label for="signup-company-vat">{{ $t('form.tva') }} </label>
              <input
                v-model="vat"
                type="text"
                class="form-control"
                id="signup-company-vat"
                :placeholder="$t('form.tva')"
              />
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="phone"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="signup-company-phone"
                  >{{ $t('form.phone') }}
                  <sup class="text-danger">*</sup></label
                >
                <input
                  v-model="phone"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                  id="signup-company-phone"
                  :readonly="isInvited"
                  :placeholder="$t('form.phone')"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="address"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="signup-company-address"
                  >{{ $t('form.address') }}
                  <sup class="text-danger">*</sup></label
                >
                <input
                  v-model="address"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                  id="signup-company-address"
                  :readonly="isInvited"
                  :placeholder="$t('form.address')"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="zipcode"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="signup-company-zipcode"
                  >{{ $t('form.zipcode') }}
                  <sup class="text-danger">*</sup></label
                >
                <input
                  v-model="zipCode"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                  id="signup-company-zipcode"
                  :readonly="isInvited"
                  :placeholder="$t('form.zipcode')"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="city"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="signup-company-city"
                  >{{ $t('form.city') }} <sup class="text-danger">*</sup></label
                >
                <input
                  v-model="city"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                  id="signup-company-city"
                  :readonly="isInvited"
                  :placeholder="$t('form.city')"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="password"
                rules="required|min:6"
                v-slot="{ errors }"
                vid="password"
              >
                <label for="signup-company-password"
                  >{{ $t('form.creatingPassword') }}
                  <sup class="text-danger">*</sup></label
                >
                <input
                  name="password"
                  v-model="password"
                  type="password"
                  class="form-control"
                  id="signup-company-password"
                  :class="{ 'is-invalid': errors.length }"
                  :placeholder="$t('form.password')"
                />
                <span class="text-muted small">{{
                  $t('form.passwordRule')
                }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <validation-provider
                name="confirmation"
                rules="required|confirmed:password"
                v-slot="{ errors }"
                vid="confirmation"
              >
                <label for="signup-company-re-password"
                  >{{ $t('form.confirmationPassword') }}
                  <sup class="text-danger">*</sup></label
                >
                <input
                  v-model="confirmed"
                  type="password"
                  class="form-control"
                  id="signup-company-re-password"
                  :class="{ 'is-invalid': errors.length }"
                  :placeholder="$t('form.password')"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12">
            <div v-if="false" class="custom-control custom-checkbox">
              <input
                v-model="optin"
                type="checkbox"
                class="custom-control-input"
                id="signup-company-check-10"
              />
              <label
                class="custom-control-label"
                for="signup-company-check-10"
                >{{ $t('form.subscriptionNewsletter') }}</label
              >
            </div>

            <div class="custom-control custom-checkbox mt-3">
              <validation-provider
                name="accepted"
                :rules="{ required: { allowFalse: false } }"
                v-slot="{ errors }"
              >
                <input
                  v-model="accepted"
                  type="checkbox"
                  class="custom-control-input"
                  :class="{ 'is-invalid': errors.length }"
                  id="signup-company-check-20"
                />
                <label
                  class="custom-control-label"
                  for="signup-company-check-20"
                >
                  {{ $t('form.accept') }}
                  <sup class="text-danger">*</sup></label
                >
              </validation-provider>
            </div>
          </div>
        </div>
      </form>
      <div class="modal-footer d-flex justify-content-between pt-3">
        <div>
          <div
            v-if="monitor.visible"
            class="px-1 text-center"
            :class="monitor.type"
          >
            {{ monitor.message }}
          </div>
        </div>
        <button
          @click="store"
          class="btn btn-primary w-50 btn-icon-right d-flex justify-content-between"
          :class="{ disabled: invalid }"
          :disabled="invalid || isSaving"
        >
          {{ $t('signUp') }}
          <div class="icon icon-arrow-right_white"></div>
        </button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import getCodeNaf from '@/js/code-naf.js'
import AdvancedSearch from 'vue-advanced-search'
import { mapFields } from 'vuex-map-fields'
import { validate, extend, ErrorBag } from 'vee-validate'
import { required, digits } from 'vee-validate/dist/rules'
import fr from 'vee-validate/dist/locale/fr'
import * as i18nIsoCountries from 'i18n-iso-countries'
i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/fr.json'))
i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/en.json'))
import Swal from 'sweetalert2'
import { mask } from 'vue-the-mask'
extend('digits', digits)

export default {
  directives: { mask },
  components: {
    Treeselect,
    AdvancedSearch,
  },
  data() {
    return {
      firstname: '',
      lastname: '',
      password: null,
      confirmed: null,
      email: null,
      vat: null,
      name: '',
      legalForm: '',
      phone: '',
      country: '',
      trade: '',
      address: '',
      city: '',
      siret: '',
      zipCode: '',
      nafCode: null,
      nafLabel: null,
      local: '',
      optin: false,
      accepted: false,
      matchPassword: true,
      countries: [],
      options: [],
      token: '',
      toClientId: '',
      isInvited: false,
      isSaving: false,
      monitor: {
        visible: false,
        message: '',
        type: 'text-warning',
      },
    }
  },
  computed: {
    ...mapFields(['user', 'apiKeyINSEE']),
  },
  created() {
    this.local = document.head.querySelector('meta[name="app-locale"]').content
    let INSEEApiKey = document.head.querySelector('meta[name="insee-api-key"]')
    this.$store.commit('SET_API_KEY_INSEE', INSEEApiKey.content)
    let countries = i18nIsoCountries.getNames(this.local, {
      select: 'official',
    })
    this.countries = Object.entries(countries).map(([key, value]) => ({
      id: key,
      name: value,
    }))
  },
  mounted() {
    if (window.location.toString().includes('/#/?token=')) {
      this.isInvited = true
      let ch = window.location.hash
      this.token = this.$lodash.replace(ch, '#/?token=', '')
      this.$store
        .dispatch('getInvitetdInformations', this.token)
        .then((resp) => {
          this.populate(resp)
        })
    }
    this.options = getCodeNaf().options
  },
  methods: {
    setCodeNAf(value) {
      this.nafLabel = value.label
    },
    validationObeserverValidate() {
      if (this.country == this.$t('france')) {
        this.name = null
      }
    },
    handleCompanySIRET(event) {
      let customSwal = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
      let siret = event.target.value
      if (siret.length > 1) {
        validate(siret, 'digits:14')
          .then((result) => {
            const { valid, errors } = result
            if (!valid) {
              return Promise.reject(this.$t('validationSiret'))
            }
            return this.$store
              .dispatch('validateCompanySiret', siret)
              .then((response) => {
                if (this.$lodash.get(response, 'data.etablissement.siret')) {
                  let etablissement = response.data.etablissement
                  let uniteLegale = etablissement.uniteLegale
                  this.name = uniteLegale.denominationUniteLegale
                } else {
                  this.name = ''
                }
              })
              .catch((error) => {
                this.name = ''
                return Promise.reject(this.$t('errors.siret', { siret: siret }))
              })
          })
          .catch((error) => {
            this.name = ''
            this.$refs.mysiret.applyResult({
              errors: [error], // array of string errors
              valid: false, // boolean state
              failedRules: {}, // should be empty since this is a manual error.
            })
            customSwal.fire({
              title: this.$t('validationSiretMessage'),
              text: error,
            })
          })
      }
    },
    populate(data) {
      console.log(data)
      this.email = data.email
      this.firstname = data.firstname
      this.lastname = data.lastname
      this.toClientId = data.to_client_id
      this.name = data.company
      this.siret = data.siret
      this.siret = data.siret
      this.legal_form = data.legalForm
      this.address = data.address
      this.city = data.city
      this.zipCode = data.zipcode
      this.phone = data.phone
      this.country = { name: data.country, id: data.countryCode }
      this.nafCode = data.nafCode
      this.nafLabel = data.nafName
    },
    store() {
      let data = {}
      this.monitor.visible = false
      this.monitor.message = ''
      this.monitor.type = ''
      data.firstname = this.firstname
      data.lastname = this.lastname
      data.email = this.email
      data.password = this.password
      data.password_confirmation = this.confirmed
      data.vat = this.vat
      data.accepted = this.accepted
      data.name = this.name
      data.trade_name = this.trade
      data.siret = this.siret
      data.legal_form = this.legalForm
      data.address = this.address
      data.city = this.city
      data.zipcode = this.zipCode
      data.country = this.country.name
      data.country_code = this.country.id
      data.optin = this.optin
      data.phone = this.phone
      data.local = this.local
      data.client_type = 2
      data.naf_code = this.nafCode
      data.naf_name = this.nafLabel
      if (this.toClientId) {
        data.to_client_id = this.toClientId
      }
      if (this.token) {
        data.token = this.token
      }
      this.isSaving = true
      this.$store
        .dispatch('signUp', data)
        .then((response) => {
          if (response.status === 201) {
            this.monitor.type = 'text-success'
            this.monitor.visible = true
            this.monitor.message = this.$t('creatingAccountSuccessMsg')
            let data = {}
            data.email = this.email
            data.password = this.password
            this.$store.dispatch('login', data)
            setTimeout(() => {
              this.monitorHide()
              $('#signupModal').modal('hide')
              this.reset()
            }, 800)
          }
        })
        .finally(() => {
          this.isSaving = false
        })
        .catch((error) => {
          this.monitor.visible = true
          if (error.response) {
            if (error.response.status == 400) {
              if (error.response.data.error.title.email) {
                this.monitor.type = 'text-danger'
                this.monitor.message = this.$t('errors.emailExist')
                this.email = null
                setTimeout(() => {
                  this.monitorHide()
                }, 3000)
              }
            } else {
              this.monitor.type = 'text-danger'
              this.monitor.message = this.$t('errors.serverError')
              setTimeout(() => {
                this.monitorHide()
              }, 3000)
            }
          }
        })
    },
    monitorHide() {
      this.monitor.type = ''
      this.monitor.message = ''
      this.monitor.visible = false
    },
    reset() {
      this.$refs.form.reset()
      this.firstname = ''
      this.lastname = ''
      this.password = null
      this.confirmed = null
      this.email = null
      this.name = ''
      this.legalForm = ''
      this.phone = ''
      this.vat = ''
      this.country = ''
      this.trade = ''
      this.address = ''
      this.city = ''
      this.siret = ''
      this.zipCode = ''
      this.optin = false
      this.accepted = false
    },
  },
  closeModal() {
    setTimeout(() => {
      this.monitor.visible = false
      this.monitor.message = ''
      $('#signupModal').modal('hide')
    }, 1000)
  },
}
</script>

<style src="vue-advanced-search/dist/AdvancedSearch.css"></style>
